// // Extend the Window interface to include RUNTIME_CONFIG
// declare global {
//   interface Window {
// 	RUNTIME_CONFIG?: {
// 	  BACKEND_URL?: string;
// 	};
//   }
// }

// // Use empty string for relative paths when running behind nginx
// export const backendURL = window.RUNTIME_CONFIG?.BACKEND_URL || process.env.REACT_APP_BACKEND_URL || "";

// src/config.ts
declare global {
	interface Window {
	  RUNTIME_CONFIG?: {
		BACKEND_URL?: string;
	  };
	}
  }
  
  // 1. Explicitly check for runtime config first
  export const getBackendUrl = (): string => {
	// Runtime configuration (from Docker environment)
	if (typeof window.RUNTIME_CONFIG?.BACKEND_URL === 'string') {
	  return window.RUNTIME_CONFIG.BACKEND_URL;
	}
  
	// Build-time configuration (from .env files)
	if (process.env.REACT_APP_BACKEND_URL) {
	  return process.env.REACT_APP_BACKEND_URL;
	}
  
	// Final fallback for local development
	return 'http://localhost:8080';
  };
  
  // 2. Use this function wherever you need the URL
  export const backendURL = getBackendUrl();
  